<template>
	<el-breadcrumb separator="">
		<el-breadcrumb-item
			v-if="currentRootItem && !currentRootItem.hideSide && routes && routes.length"
		>
			<div class="showBox" @click="showAside" v-if="!show_aside">
				<el-icon size="16px"><Fold /></el-icon>
			</div>
			<div class="showBox2" @click="showAside" v-if="show_aside">
				<el-icon size="16px"><Expand /></el-icon>
			</div>
		</el-breadcrumb-item>
		<el-breadcrumb-item
			v-for="(item, index) in breadList"
			:key="item.path"
			:index="index"
			@click="breadcrumbClick(item, index)"
			@contextmenu.prevent="breadcrumbContextmenu(item, index, $event)"
			:style="{
				cursor: 'pointer',
				backgroundColor: item.is_active ? '#409EFF' : '#e0e6ed',
				color: item.is_active ? '#fff' : '#fff',
				fontWeight: item.is_active ? 'bold' : 'normal',
				borderRadius: '4px',
				padding: '6px 12px',
				userSelect: 'none',
				margin: '0 4px'
			}"
		>
			<div class="itemTitle">
				<span>{{ item.meta.title }}</span>
				<el-icon @click.stop="closeOutSelectedTag(item)" v-if="breadList.length > 1"
					><CloseBold class="el-icon-close"
				/></el-icon>
			</div>
		</el-breadcrumb-item>
	</el-breadcrumb>
</template>

<script setup>
import { Fold, Expand, CloseBold } from '@element-plus/icons-vue'

// Props
const props = defineProps({
	currentRootItem: {
		type: Object,
		default: null
	},
	routes: {
		type: Array,
		default: () => []
	},
	show_aside: {
		type: Boolean,
		default: false
	},
	breadList: {
		type: Array,
		default: () => []
	}
})

// Emits
const emit = defineEmits(['show-aside', 'breadcrumb-click', 'breadcrumb-contextmenu', 'close-out-selected-tag'])

// Methods
const showAside = () => {
	emit('show-aside')
}

const breadcrumbClick = (item, index) => {
	emit('breadcrumb-click', item, index)
}

const breadcrumbContextmenu = (item, index, event) => {
	emit('breadcrumb-contextmenu', item, index, event)
}

const closeOutSelectedTag = (item) => {
	emit('close-out-selected-tag', item)
}
</script>

<style scoped lang="scss">
.showBox {
	cursor: pointer;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 0 50% 50% 0;
	z-index: 100;
}

.showBox2 {
	cursor: pointer;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 0 50% 50% 0;
	z-index: 100;
}

.el-breadcrumb {
	display: flex;
	align-items: center;
	overflow-x: auto;
	white-space: nowrap;
	margin: 0 0 10px;
}

.itemTitle {
	display: flex;
	justify-content: space-between;
	align-items: center;

	.el-icon-close {
		width: 16px;
		height: 16px;
		vertical-align: 2px;
		border-radius: 50%;
		text-align: center;
		transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		transform-origin: 100% 50%;

		&:before {
			transform: scale(0.6);
			display: inline-block;
			vertical-align: -3px;
		}

		&:hover {
			background-color: var(--tags-close-hover, #b4bccc);
			color: #fff;
			width: 12px !important;
			height: 12px !important;
		}
	}
}

:deep(.el-breadcrumb__separator) {
	display: none;
}
</style>
